import axios from "axios";
import IndexedDBHelperV2 from "../offline/apis/indexDBManager-v2";
import { Constants } from "../constants/constants";
const dbHelper = new IndexedDBHelperV2(Constants.DB_NAME, Constants.DB_VERSION, Constants.STORE_CONFIG);

const METHOD = {
    GET: 'GET',
    PUT: 'PUT',
    DELETE: 'DELETE',
    POST: 'POST'
};

const APPLICATION_JSON = 'application/json';

const httpClient = {

    call: (url, parameters) => {
        const finalUrl = `${url}`;

        console.log(parameters)

        const options = {
            ...parameters,
            // withCredentials: true, // For Mobile App Don't enable
            url: finalUrl
        };

        console.log(options)

        axios.interceptors.response.use(function (response) {
            return response;
        }, function (error) {
            if (401 === error.response.status && error.config && !error.config.__isRetryRequest) {
                error.config.__isRetryRequest = true;
                console.log('401 detected, redirecting to login');
                if (Constants.ELECTRON_BUILD) {
                    console.log(window.location)
                    window.location.hash = '#/school/login';
                } else {
                    window.location = '/login';
                }

                return Promise.reject(
                    error
                );
            } else {
                return Promise.reject(error);
            }
        });

        console.log(options)

        return axios(options);
    },

    parameters: (cookie, method = METHOD.GET, body = {}, option = {}) => {

        const withBody = [METHOD.PUT, METHOD.POST, METHOD.DELETE];

        if (!cookie)
            cookie = "";

        return dbHelper.getData(Constants.COOKIE_STORE, 'session').then(resCookie => {
            console.log(resCookie)
            const params = {
                method,
                headers: {
                    'content-type': APPLICATION_JSON,
                    // 'Access-Control-Allow-Origin': '*',
                    // 'Accept': 'application/pdf',
                    // 'token': resCookie ? resCookie.value : '', // For Mobile App also enable
                    // 'session-token' : resCookie ? resCookie.value : '',
                    //'Access-Control-Allow-Origin': '*',
                    // 'authorization': resCookie ? resCookie.value : '',
                    'X-Requested-With': 'XMLHttpRequest'
                },
            };

            if (option.responseType) {
                params.responseType = option.responseType
            }

            if (withBody.indexOf(method) !== -1) {
                params.data = JSON.stringify(body);
            }

            return params;
        })

    },

    // get: (url, cookie, option) => {
    //     return httpClient.call(url, httpClient.parameters(cookie, METHOD.GET, {}, option), METHOD.GET).then(response => {
    //         // returning the data here allows the caller to get it through another .then(...)
    //         return response.data
    //             ;
    //     });
    // },

    // post: (url, cookie, body = {}) => {
    //     return httpClient.call(url, httpClient.parameters(cookie, METHOD.POST, body));
    // },

    // put: (url, cookie, body = {}) => {
    //     return httpClient.call(url, httpClient.parameters(cookie, METHOD.PUT, body));
    // },

    // delete: (url, cookie, body = {}) => {
    //     return httpClient.call(url, httpClient.parameters(cookie, METHOD.DELETE, body));
    // }


    get: (url, cookie, option) => {
        // Call httpClient.parameters and chain .then() to wait for it to resolve
        return httpClient.parameters(cookie, METHOD.GET, {}, option).then(params => {
            // Use the resolved params in the httpClient.call method
            return httpClient.call(url, params, METHOD.GET).then(response => {
                // Return the response data so it can be accessed through .then() on the get method
                return response.data;
            });
        });
    },

    post: (url, cookie, body = {}) => {
        // Resolve parameters before calling httpClient.call
        return httpClient.parameters(cookie, METHOD.POST, body).then(params => {
            return httpClient.call(url, params, METHOD.POST);
        });
    },

    put: (url, cookie, body = {}) => {
        // Resolve parameters before calling httpClient.call
        return httpClient.parameters(cookie, METHOD.PUT, body).then(params => {
            return httpClient.call(url, params, METHOD.PUT);
        });
    },

    delete: (url, cookie, body = {}) => {
        // Resolve parameters before calling httpClient.call
        return httpClient.parameters(cookie, METHOD.DELETE, body).then(params => {
            return httpClient.call(url, params, METHOD.DELETE);
        });
    },

};

export default httpClient;
